export default "__VITE_ASSET__MJ2LpNMg__"